import { ApiResponse, customFetch } from './CustomFetch';
import { DocumentReferenceViewModel } from '../model/DocumentReferenceViewModel';
import download from 'downloadjs';

export const downloadExamCaseDocument = (fileName: string) => {
  return customFetch(`examCase/${fileName}`)
    .then((response) => response.blob())
    .then(blob => {
      download(blob, fileName)
    });
}

export const fetchExamCaseDocuments = (): Promise<DocumentReferenceViewModel[]> => {
  return customFetch('examCase')
    .then((response) => response.json() as Promise<ApiResponse<DocumentReferenceViewModel[]>>)
    .then((apiResponse) => apiResponse.data);
};
